module.exports = __webpack_public_path__ + "static/img/cell2.3390b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cell2.png
// module id = Fscf
// module chunks = 0